import { styled } from '@mui/material';

import { useParams } from 'react-router';

import { Typography, Card, Button } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';
import {
  useAiChatContext,
  useUserSimulationControl,
} from '@app-velocity/modules/scenarios';
import { PrototypesIcon } from '@app-velocity/icons';

const Title = styled(Typography)({
  color: 'var(--text-text-tertiary-color)',
  fontWeight: 400,
  fontSize: 13,
});

const Description = styled(Typography)({
  color: 'var(--text-text-primary-color)',
  fontWeight: 400,
  fontSize: 12,
});

const PrototypeNameContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  svg: {
    fill: 'var(--text-text-primary-color)',
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const SimulationChallenge = () => {
  const { teamId, workspaceId } = useParams<{
    teamId: string;
    workspaceId: string;
  }>();
  const { scenario, latestSimulationWithSelectedPersona, review, persona } =
    useAiChatContext();
  const { t } = useI18n();
  const { start } = useUserSimulationControl();

  const handleStart = () => {
    if (!scenario || !workspaceId || !teamId) return;
    start(teamId, workspaceId, scenario.id!, persona, 1, true);
  };

  return (
    <StyledCard>
      <div>
        <Title variant="subtitle2">{t('prototypes:task_description')}</Title>
        <Description variant="body2">{scenario.introMessage}</Description>
      </div>
      {scenario.name ? (
        <PrototypeNameContainer>
          <PrototypesIcon /> <Description>{scenario.name}</Description>
        </PrototypeNameContainer>
      ) : null}
      {!latestSimulationWithSelectedPersona &&
      review.reviewStatus !== 'IN_PROGRESS' ? (
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleStart}
        >
          {t('prototypes:run_a_simulation')} <PrototypesIcon />
        </Button>
      ) : null}
    </StyledCard>
  );
};
